$(document).ready(function () {
	"use strict";

	const portfolioName = window.location.href.split("/").pop();

	if (portfolioName !== 'income-formula' && portfolioName !== 'investments-in-yuan') {
		const $dropdownColl = document.querySelectorAll('.main .js-dropdown-item');
		const $closeDropdownButton = document.querySelector('.main .js-close-dropdown');
		const $closeDropdownIcon = $closeDropdownButton.querySelector('.js-close-icon');
		const $dropdownList = document.querySelector('.main .js-dropdown-list');

		$dropdownColl.forEach((element, index) => {
			if (index === 0) {
				const $partsContent = element.querySelector('.js-parts-content');
				const $dropdownContent = element.querySelector('.js-dropdown-content');
				const $dropdownIcon = element.querySelector('.js-dropdown-icon');

				element.classList.toggle('active');
				$partsContent.classList.add('active');
				$dropdownContent.classList.add('active');
				$dropdownIcon.classList.add('active');
			}
			element.addEventListener('click', () => {
				const $partsContent = element.querySelector('.js-parts-content');
				const $dropdownContent = element.querySelector('.js-dropdown-content');
				const $dropdownIcon = element.querySelector('.js-dropdown-icon');

				element.classList.toggle('active');
				$partsContent.classList.toggle('active');
				$dropdownContent.classList.toggle('active');
				$dropdownIcon.classList.toggle('active');
			})
		});

		//Скрываем половину дропдаунов
		const dropdownItems = $dropdownList.querySelectorAll('.js-dropdown-item');
		const halfItems = [...dropdownItems].slice(5);
		halfItems.map((item) => {
			item.classList.add('hidden');
		})

		$closeDropdownButton.addEventListener('click', () => {
			const dropdownItems = $dropdownList.querySelectorAll('.js-dropdown-item');
			const halfItems = [...dropdownItems].slice(5);
			halfItems.map((item) => {
				item.classList.toggle('hidden')
			})

			$closeDropdownIcon.classList.toggle('active');
		});
	}

	function paintChart(data, label){
		if (portfolioName !== 'income-formula') {

			const portfolioProcentages = {
				"egs-balanced": data,
				"egs-moderately": data,
				"egs-high": data,
				"momentum": data,
				"egs-low-regular": data,
				"egs-balanced-regular": data,
				"income-formula": 8,
				"investments-in-yuan": data,
				"currency-perspective": data,
			};

			const portfolioRotation = {
				"egs-balanced": 100,
				"egs-moderately": 130,
				"egs-high": -120,
				"momentum": 100,
				"egs-low-regular": 190,
				"egs-balanced-regular": 130,
				"income-formula": 8,
				"investments-in-yuan": 8,
				"currency-perspective": 477,
			};

			const offsetValues = portfolioProcentages[portfolioName][0] > portfolioProcentages[portfolioName][1] ? [0, 25] : [25, 0];
			const rotationValue = portfolioProcentages[portfolioName][0] > portfolioProcentages[portfolioName][1] ? 120 : 0;

			const $chart = document.getElementById('chart')?.getContext("2d");

			//Добавляем диаграмму
			var gradient1 = $chart?.createLinearGradient(0, 1, 0, 175);
			gradient1?.addColorStop(1, 'rgba(166, 223, 255, 1)');
			gradient1?.addColorStop(0, 'rgba(152, 162, 237, 1)');
			gradient1?.addColorStop(0, 'rgba(152, 162, 237, 1)');

			// var gradient2 = $chart.createLinearGradient(1, 0, 0, 89);
			// gradient2.addColorStop(1, 'rgba(255, 255, 0, 1)');
			// gradient2.addColorStop(0, 'rgba(0, 217, 0, 1)');
			var gradient2 = $chart?.createLinearGradient(1, 0, 0, 89);
			gradient2?.addColorStop(1, 'rgba(143, 255, 0, 1)');
			gradient2?.addColorStop(0, 'rgba(0, 217, 0, 1)');

			var gradient3 = $chart?.createLinearGradient(1, 1, 0, 175);
			gradient3?.addColorStop(1, 'rgba(255, 208, 87, 1)');
			gradient3?.addColorStop(0, 'rgba(255, 121, 46, 1)');

			new Chart($chart, {
				type: 'doughnut',
				data: {
					// labels: ['Dairy', 'Fruits', 'Lean meats', 'Vegetables', 'Whole grains'],
					datasets: [{
						//data: [portfolioProcentages[portfolioName][0], portfolioProcentages[portfolioName][1], portfolioProcentages[portfolioName][2], portfolioProcentages[portfolioName][3]],
						data: portfolioProcentages[portfolioName],
						backgroundColor: [gradient1, '#8DEE00', gradient3, 'yellow', getRandomColor(), getRandomColor(), getRandomColor()],
						borderWidth: 0.5,
						// fillColor: [gradient1],
						// borderColor: '#ddd'
						// hoverOffset: 15,
					}],
				},
				options: {
					// offset: offsetValues,
					rotation: portfolioRotation[portfolioName],
					// cutout: 38,
					cutout: 45,
					title: {
						display: false,
						text: 'Recommended Daily Diet',
						position: 'top',
						fontSize: 16,
						fontColor: '#111',
						padding: 20
					},
					legend: {
						display: false,
						position: 'bottom',
						labels: {
							boxWidth: 20,
							fontColor: '#111',
							padding: 15
						}
					},
					tooltips: {
						enabled: false
					},
					events: [],
					plugins: {
						datalabels: {
							color: '#111',
							textAlign: 'center',
							font: {
								lineHeight: 1.6
							},
							formatter: function(value, ctx) {
								return ctx.chart.data.labels[ctx.dataIndex] + '\n' + value + '%';
							}
						},
					}

				}
			});

			// const $obligation = document.querySelector('.js-percent-obligation');
			// const $stocks = document.querySelector('.js-percent-stocks');
			// const $markets = document.querySelector('.js-percent-money');
			// const $accounts = document.querySelector('.js-percent-accounts');

			// const $obligationTitle = document.querySelector('.js-title-obligation');
			// const $stocksTitle = document.querySelector('.js-title-stocks');
			// const $marketsTitle = document.querySelector('.js-title-money');
			// const $accountsTitle = document.querySelector('.js-title-accounts');

			// $obligation.innerText = `${data[0]}%`;
			// $stocks.innerText = `${data[1]}%`;
			// $markets.innerText = `${data[2]}%`;
			// if($accounts){
			// 	$accounts.innerText = `${data[3]}%`;
			// }

			// $obligationTitle.innerText = `${label[0]}`;
			// $stocksTitle.innerText = `${label[1]}`;
			// $marketsTitle.innerText = `${label[2]}`;
			// if($accountsTitle){
			// 	$accountsTitle.innerText = `${label[3]}`;
			// }

			createBadges(data.slice(0, 4), label.slice(0, 4))
		}
	}

	function createBadges(data, label){
		console.log(data, label)
		let selectorsCollection = [...document.querySelectorAll('.new-briefcase__sectors')]
		selectorsCollection.map(el => el.innerHTML = '')
		data.map((el, index) => {
			if(el > 0 || el.length > 0){
				let percent = document.createElement('div')
				percent.classList.add('new-briefcase__percent')
				let percentName = document.createElement('p')
				percentName.classList.add('new-briefcase__percent-name')
				let percentValue = document.createElement('div')
				percentValue.classList.add('new-briefcase__percent-value')
				percentName.textContent = label[index]
				percentValue.textContent = el + '%'
				percent.appendChild(percentName)
				let a = index
				switch (a) {
					case 0:
						percentValue.classList.add('new-briefcase__percent-value--blue')
						percent.appendChild(percentValue)
						break;
					case 1:
						percentValue.classList.add('new-briefcase__percent-value--green')
						percent.appendChild(percentValue)
						break;
					case 2:
						percentValue.classList.add('new-briefcase__percent-value--orange')
						percent.appendChild(percentValue)
						break;
					case 3:
						percentValue.classList.add('new-briefcase__percent-value--yellow')
						percent.appendChild(percentValue)
						break;
					default:
						alert( "Нет таких значений" );
				}
				switch (a) {
					case 0:
					case 1:
						selectorsCollection[0]?.appendChild(percent)
						break;
					case 2:
					case 3:
						selectorsCollection[1]?.appendChild(percent)
						break;
					default:
						alert("Нет таких значений");
				}
			}
		})
	}

	let portfolioNameCompare = {}

	if(window.location.host === 'sberbank-insurance.ru' || window.location.host === 'www.sberbank-insurance.ru' || window.location.host === 'test-sbercloud.sberbank-insurance.ru'){
		portfolioNameCompare = {
			"egs-balanced": 1,
			"egs-moderately": 3,
			"egs-high": 2,
			"momentum": 4,
			"egs-low-regular": 7,
			"egs-balanced-regular": 6,
			"income-formula": 151,
			"investments-in-yuan": 474,
			"currency-perspective": 477,
		};
	}
	else {
		portfolioNameCompare = {
			"egs-balanced": 1,
			"egs-moderately": 3,
			"egs-high": 2,
			"momentum": 4,
			"egs-low-regular": 7,
			"egs-balanced-regular": 6,
			"income-formula": 61,
			"investments-in-yuan": 61,
			"currency-perspective": 477,
		};
	}


	$.ajax({
		type: "GET",
		url: ` /managed-capital/get-portfolio-compound?portfolio=${portfolioNameCompare[portfolioName]}`,
		success: function (params) {
			if (portfolioNameCompare[portfolioName] === 61 || portfolioNameCompare[portfolioName] === 151) {
				// if(window.location.host !== 'sberins.dg-prod.su'){
				// 	params = [{name: 'БПИФ "Первая - Фонд Топ Российских акций"', share: 18, color: 'linear-gradient(303.05deg, #FFFF68 5.98%, #2BFC2B 80.29%)'},
				// 		{name: 'БПИФ "Первая - Фонд Корпоративные облигации"', share: 9, color: 'linear-gradient(256.9deg, #1AC8FF -6.26%, #6CFFF6 90.56%);'},
				// 		{name: 'БПИФ "Первая - Фонд Государственные облигации"', share: 27, color: 'linear-gradient(67.53deg, #FFD057 14.63%, #FF792E 94.5%)'},
				// 		{name: 'БПИФ "Первая – Фонд Доступное золото"', share: 9, color: 'linear-gradient(90deg, #8AFF92 -11.29%, #61FF39 100%)'},
				// 		{name: "Денежный рынок", share: 37, color: 'linear-gradient(111.29deg, #87DAFF 14.02%, #5B9DFF 85.98%)'}];
				// }
				//
				//
				// const fractionList = document.querySelector('.js-fraction-list');
				// fractionList.innerHTML = '';
				//
				// const colors = [
				// 	'linear-gradient(303.05deg, #FFFF68 5.98%, #2BFC2B 80.29%)',
				// 	'linear-gradient(256.9deg, #1AC8FF -6.26%, #6CFFF6 90.56%)',
				// 	'linear-gradient(67.53deg, #FFD057 14.63%, #FF792E 94.5%)',
				// 	'linear-gradient(90deg, #8AFF92 -11.29%, #61FF39 100%)',
				// 	'linear-gradient(111.29deg, #87DAFF 14.02%, #5B9DFF 85.98%)',
				// ]
				//
				//
				// params.slice(0, 10).map(({ name, share }, index) => {
				// 	fractionList.insertAdjacentHTML(
				// 		"beforeend",
				// 		`<li class="new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2 js-item" data-number="${index}">
				// 			<p class="new-briefcase__fraction-name new-briefcase__fraction-name-2 js-name">${name}</p>
				// 			<div class="new-briefcase__fraction-progress js-progress">
				// 				<div class="new-briefcase__fraction-fill" style="width:${share}%; background: ${colors[index]};"></div>
				// 			</div>
				// 			<p class="new-briefcase__fraction-percent js-percent">${share}%</p>
				// 		</li>`
				// 	);
				// });

			} else {
				const fractionList = document.querySelector('.js-fraction-list');
				if (fractionList) {
					fractionList.innerHTML = '';

					let restProcents = 0;

					let sumForCurrencyPerspective = 0

					// if(portfolioName === 'investments-in-yuan'){
					// 	params = [
					// 		{
					// 			"name": "Металлургия",
					// 			"share": 37.80
					// 		},
					// 		{
					// 			"name": "Нефть и газ",
					// 			"share": 9.50
					// 		},
					// 		{
					// 			"name": "Транспорт",
					// 			"share": 9.50
					// 		},
					// 		{
					// 			"name": "Финансы",
					// 			"share": 9.50
					// 		},
					// 		{
					// 			"name": "Химическая промышленность",
					// 			"share": 9.50
					// 		},
					// 		{
					// 			"name": "Потребительский сектор",
					// 			"share": 5
					// 		},
					// 	]
					// }
					// else if(portfolioName === 'currency-perspective'){
					// 	params = [
					// 		{
					// 			"name": "Нефтегаз",
					// 			"share": 80
					// 		},
					// 		{
					// 			"name": "Строительная",
					// 			"share": 10
					// 		},
					// 		{
					// 			"name": "Оборудование и услуги для добычи нефти и газа",
					// 			"share": 10
					// 		},
					// 	]
					// }

					params.map(({name, share}) => {
						if (name === 'Денежный рынок') {
							return sumForCurrencyPerspective = sumForCurrencyPerspective + share
						}
						else if (name === "Расчетные счета") {
							return sumForCurrencyPerspective = sumForCurrencyPerspective + share
						}
					})
					params.map(({ name, share, color }, index) => {
						if (index >= 7 && name !== "Расчетные счета") {
							return restProcents += +share;
						}
						if(share > 0){
							if (name === 'Денежный рынок') {
								fractionList.insertAdjacentHTML(
									"beforeend",
									`<li class="${portfolioName !== 'income-formula' ? 'new-briefcase__fraction-item' : ''} ${portfolioName === 'income-formula' && 'new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2'} js-item" data-number="${index}">
											<p class="new-briefcase__fraction-name ${portfolioName === 'income-formula' && 'new-briefcase__fraction-name-2'} js-name">${name}</p>
											<div class="new-briefcase__fraction-progress js-progress">
												<div class="new-briefcase__fraction-fill" style="width:${share}%; ${portfolioName === 'income-formula' && `background: ${color}`}"></div>
											</div>
											<p class="new-briefcase__fraction-percent js-percent">${sumForCurrencyPerspective.toFixed(2)}%</p>
										</li>`
								);
							}
							else if (name === "Расчетные счета") {
								return null
							}
							else {
								fractionList.insertAdjacentHTML(
									"beforeend",
									`<li class="${portfolioName !== 'income-formula' ? 'new-briefcase__fraction-item' : ''} ${portfolioName === 'income-formula' && 'new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2'} js-item" data-number="${index}">
											<p class="new-briefcase__fraction-name ${portfolioName === 'income-formula' && 'new-briefcase__fraction-name-2'} js-name">${name}</p>
											<div class="new-briefcase__fraction-progress js-progress">
												<div class="new-briefcase__fraction-fill" style="width:${share}%; ${portfolioName === 'income-formula' && `background: ${color}`}"></div>
											</div>
											<p class="new-briefcase__fraction-percent js-percent">${share}%</p>
										</li>`
								);
							}
							// if (portfolioName === "currency-perspective") {
							// 	if (name === 'Денежный рынок') {
							// 		fractionList.insertAdjacentHTML(
							// 			"beforeend",
							// 			`<li class="${portfolioName !== 'income-formula' ? 'new-briefcase__fraction-item' : ''} ${portfolioName === 'income-formula' && 'new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2'} js-item" data-number="${index}">
							// 				<p class="new-briefcase__fraction-name ${portfolioName === 'income-formula' && 'new-briefcase__fraction-name-2'} js-name">${name}</p>
							// 				<div class="new-briefcase__fraction-progress js-progress">
							// 					<div class="new-briefcase__fraction-fill" style="width:${share}%; ${portfolioName === 'income-formula' && `background: ${color}`}"></div>
							// 				</div>
							// 				<p class="new-briefcase__fraction-percent js-percent">${sumForCurrencyPerspective.toFixed(2)}%</p>
							// 			</li>`
							// 		);
							// 	}
							// 	else if (name === "Расчетные счета") {
							// 		return null
							// 	}
							// 	else {
							// 		fractionList.insertAdjacentHTML(
							// 			"beforeend",
							// 			`<li class="${portfolioName !== 'income-formula' ? 'new-briefcase__fraction-item' : ''} ${portfolioName === 'income-formula' && 'new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2'} js-item" data-number="${index}">
							// 				<p class="new-briefcase__fraction-name ${portfolioName === 'income-formula' && 'new-briefcase__fraction-name-2'} js-name">${name}</p>
							// 				<div class="new-briefcase__fraction-progress js-progress">
							// 					<div class="new-briefcase__fraction-fill" style="width:${share}%; ${portfolioName === 'income-formula' && `background: ${color}`}"></div>
							// 				</div>
							// 				<p class="new-briefcase__fraction-percent js-percent">${share}%</p>
							// 			</li>`
							// 		);
							// 	}
							// }
							// else {
							// 	fractionList.insertAdjacentHTML(
							// 		"beforeend",
							// 		`<li class="${portfolioName !== 'income-formula' ? 'new-briefcase__fraction-item' : ''} ${portfolioName === 'income-formula' && 'new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2'} js-item" data-number="${index}">
							// 			<p class="new-briefcase__fraction-name ${portfolioName === 'income-formula' && 'new-briefcase__fraction-name-2'} js-name">${name}</p>
							// 			<div class="new-briefcase__fraction-progress js-progress">
							// 				<div class="new-briefcase__fraction-fill" style="width:${share}%; ${portfolioName === 'income-formula' && `background: ${color}`}"></div>
							// 			</div>
							// 			<p class="new-briefcase__fraction-percent js-percent">${share}%</p>
							// 		</li>`
							// 	);
							// }
						}
					});
					if(restProcents > 0){
						fractionList.insertAdjacentHTML(
							"beforeend",
							`<li class="new-briefcase__fraction-item js-item">
							<p class="new-briefcase__fraction-name js-name">Другое</p>
							<div class="new-briefcase__fraction-progress js-progress">
								<div class="new-briefcase__fraction-fill" style="width:${restProcents}%;"></div>
							</div>
							<p class="new-briefcase__fraction-percent js-percent">${restProcents.toFixed(2)}%</p>
						</li>`
						);
					}
				}
			}
		},
		errors: function (errors) {
			console.log(errors);
		},
	});

	if (portfolioName === 'income-formula'){
		$.ajax({
			type: "GET",
			url: ` /managed-capital/get-portfolio-issuers?portfolio=${portfolioNameCompare[portfolioName]}`,
			success: function (params) {
				// if(portfolioName === 'investments-in-yuan'){
				// 	params = [
				// 		{
				// 			shortname: 'Инструменты денежного рынка',
				// 			name: 'Инструменты денежного рынка',
				// 			fact: '80',
				// 		},
				// 		{
				// 			shortname: 'Облигации в юанях',
				// 			name: 'Облигации в юанях',
				// 			fact: '10',
				// 		},
				// 		{
				// 			shortname: 'Фонд облигации в юанях',
				// 			name: 'Фонд облигации в юанях',
				// 			fact: '10',
				// 		}
				// 	]
				// }
				// if(portfolioName === 'currency-perspective'){
				// 	params = [
				// 		{
				// 			shortname: 'Инструменты денежного рынка',
				// 			name: 'Инструменты денежного рынка',
				// 			fact: '80',
				// 		},
				// 		{
				// 			shortname: 'Корпоративные облигации в $',
				// 			name: 'Корпоративные облигации в $',
				// 			fact: '10',
				// 		},
				// 		{
				// 			shortname: 'Еврооблигации МинФина РФ в $',
				// 			name: 'Еврооблигации МинФина РФ в $',
				// 			fact: '10',
				// 		}
				// 	]
				// }

				const fractionList = document.querySelector('.js-fraction-list');
				fractionList.innerHTML = '';

				const colors = [
					'linear-gradient(303.05deg, #FFFF68 5.98%, #2BFC2B 80.29%)',
					'linear-gradient(256.9deg, #1AC8FF -6.26%, #6CFFF6 90.56%)',
					'linear-gradient(67.53deg, #FFD057 14.63%, #FF792E 94.5%)',
					'linear-gradient(90deg, #8AFF92 -11.29%, #61FF39 100%)',
					'linear-gradient(111.29deg, #87DAFF 14.02%, #5B9DFF 85.98%)',
				]


				params.slice(0, 10).map(({ shortname, name, fact }, index) => {
					fractionList.insertAdjacentHTML(
						"beforeend",
						`<li class="new-briefcase__fraction-item-2--newColumns new-briefcase__fraction-item-2 js-item" data-number="${index}">
							<p class="new-briefcase__fraction-name new-briefcase__fraction-name-2 js-name">${shortname !== null ? (shortname === 'Минфин РФ' ? 'Денежный рынок' : shortname) : name}</p>
							<div class="new-briefcase__fraction-progress js-progress">
								<div class="new-briefcase__fraction-fill" style="width:${fact}%; background: ${colors[index]};"></div>
							</div>
							<p class="new-briefcase__fraction-percent js-percent">${fact}%</p>
						</li>`
					);
				});

				// let height = $('.new-briefcase__fraction-list').height() + 80
				// $('.new-briefcase__fraction-list').css('height', height + 'px')
				console.log(params[0])
				if (params[0].date) {
					$('.new-briefcase__current-info span').text(params[0].date.split("-").reverse().join("."));
				} else {
					// Действие, если date не существует
					$('.new-briefcase__current-info span').style.display = 'none';
				}
			},
			errors: function (errors) {
				console.log(errors);
			},
		});
	}

	if (portfolioName !== 'income-formula'){
		if(window.location.pathname.substr(0, 17) === '/managed-capital/' || window.location.pathname.substr(0, 24) === '/capitalmanagedpartners/' || window.location.pathname.substr(0, 16) === '/capitalmanaged/'){
			let portfolioId = {}
			if(window.location.host === 'sberbank-insurance.ru' || window.location.host === 'www.sberbank-insurance.ru' || window.location.host === 'test-sbercloud.sberbank-insurance.ru'){
				portfolioId = {
					"egs-balanced": 1,
					"egs-moderately": 3,
					"egs-high": 2,
					"momentum": 4,
					"egs-low-regular": 7,
					"egs-balanced-regular": 6,
					"investments-in-yuan": 474,
					"currency-perspective": 477,
				};
			}
			else {
				portfolioId = {
					"egs-balanced": 1,
					"egs-moderately": 3,
					"egs-high": 2,
					"momentum": 4,
					"egs-low-regular": 8,
					"egs-balanced-regular": 7,
					"investments-in-yuan": 61,
					"currency-perspective": 477,
				};
			}
			$.ajax({
				url: `/managed-capital/get-portfolio-issuers?portfolio=${portfolioId[portfolioName]}`,
				method: 'get',
				dataType: 'json',
				success: function(data){
					listGeneration(data)
				}
			});
			$.ajax({
				url: `/managed-capital/get-portfolio-top-assets?portfolio=${portfolioId[portfolioName]}`,
				method: 'get',
				dataType: 'json',
				success: function(data){
					let diagramData = []
					let diagramLabel = []
					Object.entries(data).map(([key, value], index) => {
						diagramData.push(Number(value.percents).toFixed(2))
						if (portfolioName === 'investments-in-yuan' && value.type === 'Паи'){
							diagramLabel.push('Финансовые услуги')
						} else {
							diagramLabel.push(value.type)
						}
					})
					// if(portfolioName === 'investments-in-yuan'){
					// 	diagramData = ['88.52', '11.5']
					// 	diagramLabel = ['Финансовые услуги', 'Расчетные счета' ]
					// }
					paintChart(diagramData, diagramLabel)
				}
			});
		}
	}

	function createListElement(element){
		let item = document.createElement('li')
		$(item).addClass('new-briefcase__parts-item js-dropdown-item')
		let partsContent = document.createElement('div')
		$(partsContent).addClass('new-briefcase__parts-content js-parts-content')
		let title = document.createElement('div')
		$(title).addClass('new-briefcase__dropdown-title')
		let info = document.createElement('div')
		$(info).addClass('new-briefcase__parts-info')
		let dropdownContent = document.createElement('div')
		$(dropdownContent).addClass('new-briefcase__dropdown-content js-dropdown-content')
		dropdownContent.textContent = element.info
		let name = document.createElement('div')
		$(name).addClass('new-briefcase__parts-name')
		name.textContent = element.shortname === null ? element.name : element.shortname
		info.insertAdjacentElement('beforeend', name)
		let type = document.createElement('div')
		$(type).addClass('new-briefcase__parts-type')
		type.textContent = element.type
		info.insertAdjacentElement('beforeend', type)
		let segment = document.createElement('div')
		$(segment).addClass('new-briefcase__parts-segment')
		segment.textContent = element.fact + '%'
		info.insertAdjacentElement('beforeend', segment)
		let icon = document.createElement('div')
		$(icon).addClass('new-briefcase__parts-icon js-dropdown-icon')
		icon.insertAdjacentHTML("beforeend", '<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'\t\t\t\t\t\t\t<path\n' +
			'\t\t\t\t\t\t\t\td="M0.00048823 1.28345C0.000488216 1.60718 0.116699 1.8728 0.332519 2.08862L6.5498 8.45532C6.83203 8.73755 7.12256 8.87866 7.47949 8.87866C7.83643 8.87866 8.13525 8.74585 8.40918 8.45532L14.6348 2.08862C14.8506 1.8645 14.9668 1.59888 14.9668 1.28345C14.9668 0.644287 14.4521 0.121338 13.813 0.121338C13.4976 0.121338 13.1987 0.25415 12.9663 0.486572L7.47949 6.1311L2.00098 0.486572C1.76855 0.25415 1.46973 0.121337 1.1543 0.121337C0.515137 0.121337 0.000488258 0.644286 0.00048823 1.28345Z"\n' +
			'\t\t\t\t\t\t\t\tfill="#3C3C43" fill-opacity="0.3"/>\n' +
			'\t\t\t\t\t\t</svg>')
		info.insertAdjacentElement('beforeend', icon)
		title.insertAdjacentElement('beforeend', info)
		title.insertAdjacentElement('beforeend', dropdownContent)
		partsContent.insertAdjacentElement('beforeend', title)
		item.insertAdjacentElement('beforeend', partsContent)
		return item
	}

	function listElementHandler(e){
		let element = e.target.closest('.js-dropdown-item');
		const $partsContent = element.querySelector('.js-parts-content');
		const $dropdownContent = element.querySelector('.js-dropdown-content');
		const $dropdownIcon = element.querySelector('.js-dropdown-icon');
		$(element).toggleClass('active');
		$($partsContent).toggleClass('active');
		$($dropdownContent).toggleClass('active');
		$($dropdownIcon).toggleClass('active');
	}

	function listGeneration(data){
		$('.new-briefcase__parts-list').empty();
		// if(portfolioName === 'investments-in-yuan'){
		// 	data = [
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 9.60,
		// 			"info": "Ведущая компания мировой алюминиевой отрасли.",
		// 			"shortname": "Русал",
		// 			"date": "2023-11-01"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 9.50,
		// 			"info": "Одна из 5 ведущих глобальных золотодобывающих компаний.",
		// 			"shortname": "Полюс",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 9.10,
		// 			"info": "Частный банк в России, занимающий четвёртое место по размеру активов.",
		// 			"shortname": "Альфа-Банк",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 9.00,
		// 			"info": "Крупный лесопромышленный холдинг, объединяющий российские и европейские предприятия.",
		// 			"shortname": "Сегежа Групп",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 8.90,
		// 			"info": "Лидер российской нефтяной отрасли.",
		// 			"shortname": "Роснефть",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 8.80,
		// 			"info": "Лидер судоходных компаний России и одним из лидеров мирового рынка танкерных перевозок.",
		// 			"shortname": "Совкомфлот",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 8.30,
		// 			"info": "Одно из ведущих золотодобывающих предприятий России.",
		// 			"shortname": "ЮГК",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 7.00,
		// 			"info": "Крупнейшая железорудная компания в России и СНГ.",
		// 			"shortname": "Металлинвест",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 5.20,
		// 			"info": "Российский химический холдинг.",
		// 			"shortname": "ФосАгро",
		// 			"date": "2023-10-31"
		// 		},
		// 		{
		// 			"type": "Облигации",
		// 			"fact": 24.60,
		// 			"info": "",
		// 			"shortname": "Прочее",
		// 			"date": "2023-10-31"
		// 		}
		// 	]
		// }
		Object.values(data).map(value => {
			let listElement = createListElement(value)
			listElement.addEventListener('click', (e) => {listElementHandler(e)})
			$('.new-briefcase__parts-list').append(listElement)
		})
		const dropdownItems = $('.new-briefcase__parts-list').find('.js-dropdown-item');
		const halfItems = [...dropdownItems].slice(5);
		halfItems.map((item) => {
			item.classList.add('hidden');
		})
		$('.new-briefcase__current-info').find('span')[0].textContent = new Date(data[0].date).toLocaleDateString('ru-RU')
	}

	function getRandomColor() {
		var letters = '0123456789ABCDEF';
		var color = '#';
		for (var i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}

})
